<template>
  <div>
    <!-- Main content goes here -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'TemplatesBlocks'
};
</script>

<style lang="scss" scoped></style>
